import { Component, OnInit } from '@angular/core';
import { UserService } from '../user.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-website-footer',
  templateUrl: './website-footer.component.html',
  styleUrls: ['./website-footer.component.css']
})
export class WebsiteFooterComponent implements OnInit {

  public name :any;
  public email:any;
  public subject:any;
  public message:any;

  constructor(public usr:UserService,
              public toastr:ToastrService,
              public router:Router) { }

  ngOnInit(): void {
  }

  send()
  {
    if(!this.name)
    {
      return this.toastr.error("Name is Empty");
    }else if(!this.email)
    {
      return this.toastr.error("Email is Empty");
    }else if(! this.subject)
    {
      return this.toastr.error("Subject is Empty");
    }else if(!this.message)
    {
      this.toastr.error("Message is Empty");
    }else {
      let obj = {
        "name": this.name,
        "email": this.email,
        "subject": this.subject,
        "message": this.message
      }
      console.log(obj);
      this.usr.connect(obj).subscribe((res:any)=>
      {
        if(res.code===200)
        {
          console.log(res);
          this.toastr.success(res.message);
        }else {
          console.log(res.message);
          this.toastr.error("Failed");
        }
      }, (err)=>
      {
        console.log(err);
      });
    }
  }
}
